export class TaxRecordModel {
   number = "";
   rnc = "";
   expirationDate = null;
}
